var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tank)?_c('CChartLine',{attrs:{"datasets":_vm.datasets,"options":_vm.options,"labels":_vm.labels}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }